import { getAuth, signInWithPopup, signInWithRedirect, GoogleAuthProvider, GithubAuthProvider } from 'firebase/auth';
import { app } from './firebaseConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axiosInstance from '../../axiosConfig';
import axios from 'axios';
import { Circles } from 'react-loader-spinner';
import '../../styles/Auth.css';

export default function OAuth() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState({ google: false, github: false });

  const handleOAuthClick = async (provider) => {
    const providerName = provider instanceof GoogleAuthProvider
      ? 'google'
      : provider instanceof GithubAuthProvider
        ? 'github'
        : 'unknown';

    setLoading((prevState) => ({ ...prevState, [providerName]: true }));

    try {
      const auth = getAuth(app);
      // console.log(`Initiating ${providerName} OAuth flow`);

      if (providerName === 'github') {
        provider.addScope('user:email');
      }

      try {
        const result = await signInWithPopup(auth, provider);
        await handleOAuthResult(result, providerName);
      } catch (popupError) {
        if (popupError.code === 'auth/popup-blocked') {
          //console.warn('Popup blocked, trying redirect instead.');
          await signInWithRedirect(auth, provider);
        } else {
          throw popupError;
        }
      }

    } catch (error) {
      if (error.response) {
        //console.error('Server responded with:', error.response.data);
      } else if (error.request) {
        // console.error('No response received:', error.request);
      } else {
        //  console.error('Error:', error.message);
      }
      // console.error('Could not sign in with OAuth provider:', error);
    } finally {
      setLoading((prevState) => ({ ...prevState, [providerName]: false }));
    }
  };

  const handleOAuthResult = async (result, providerName) => {
    const idToken = await result.user.getIdToken();
    let email = result.user.email;

    if (!email && providerName === 'github') {
      const githubAccessToken = result._tokenResponse.oauthAccessToken;

      try {
        const userResponse = await axios.get('https://api.github.com/user', {
          headers: {
            Authorization: `Bearer ${githubAccessToken}`
          }
        });
        email = userResponse.data.email || null;
      } catch (userError) {
        //console.error('Error fetching user profile:', userError);
      }

      if (!email) {
        try {
          const githubEmailsResponse = await axios.get('https://api.github.com/user/emails', {
            headers: {
              Authorization: `Bearer ${githubAccessToken}`
            }
          });
          const primaryEmail = githubEmailsResponse.data.find(emailObj => emailObj.primary)?.email;
          email = primaryEmail || null;
        } catch (emailsError) {
          // console.error('Error fetching emails list:', emailsError);
        }
      }
    }

    if (!email) {
      throw new Error('User email is null');
    }

    //console.log(`OAuth with ${providerName}, email: ${email}`);

    const endpoint = providerName === 'google'
      ? '/api/auth/google'
      : providerName === 'github'
        ? '/api/auth/github'
        : '/api/auth/unknown';

    const referralCode = new URLSearchParams(location.search).get('referralCode');

    const response = await axiosInstance.post(endpoint, {
      email,
      referralCode,
    });

    const { accessToken, refreshToken, invitationLink, user } = response.data;

    login({ email: user.email, id: user.id, isAdmin: user.isAdmin }, accessToken, refreshToken, invitationLink);

    localStorage.setItem('accessToken', accessToken);

    localStorage.setItem('refreshToken', refreshToken);

    navigate("/");
  };

  return (
    <div className="social-login-container">
      <p>You can also sign up or log in using your Google account.</p>

      <button
        onClick={() => handleOAuthClick(new GoogleAuthProvider())}
        type="button"
        className="oauth-button google-button"
        disabled={loading.google}
      >
        {loading.google ? (
          <Circles
            height="20"
            width="20"
            color="#ffffff"
            ariaLabel="circles-loading"
            wrapperStyle={{ display: 'flex', justifyContent: 'center' }}
            visible={true}
          />
        ) : (
          'Continue with Google'
        )}
      </button>

      {/* <button
        onClick={() => handleOAuthClick(new GithubAuthProvider())}
        type="button"
        className="oauth-button github-button"
        disabled={loading.github}
      >
        {loading.github ? (
          <Circles
            height="20"
            width="20"
            color="#ffffff"
            ariaLabel="circles-loading"
            wrapperStyle={{ display: 'flex', justifyContent: 'center' }}
            visible={true}
          />
        ) : (
          'Continue with GitHub'
        )}
      </button> */}
    </div>
  );
}
